// Footer component — persistent at bottom of main content area.

import { useTranslation } from 'react-i18next'

export function Footer() {
  const { t } = useTranslation('layout')

  return (
    <footer className="border-t bg-footer px-4 py-2">
      <div className="flex items-center justify-between text-xs text-footer-foreground">
        <span>{t('footer.copyright', { year: new Date().getFullYear() })}</span>
        <span>{t('footer.version')}</span>
      </div>
    </footer>
  )
}
